import React, { Component } from 'react'

import Switch from 'react-switch'
import Button from 'components/common/Button'
import Option from './Option/Option'
import { connect } from 'react-redux'
import AddIcon from 'assets/icons/add-icon-theme.png'
import styles from './third-step.scss'
import { changeSignUpForm } from 'src/actions/timepoll'
import PropTypes from 'prop-types'

const initialOption = {
  item: '',
  item_rank: 0,
  count_limit: 9999,
  description: ''
}

class ThirdStep extends Component {
  state = {
    openSwitch: false
  }

  _addOption = () => {
    const {
      signUpForm: { list_options_params },
      onChangeSignUpForm,
      signUpForm
    } = this.props
    list_options_params.push({ ...initialOption, item_rank: list_options_params.length })
    onChangeSignUpForm({ ...signUpForm, list_options_params })
  }

  _removeOption = index => {
    let {
      signUpForm: { list_options_params },
      onChangeSignUpForm,
      signUpForm
    } = this.props
    list_options_params.splice(index, 1)

    list_options_params = list_options_params.map((item, index) => ({ ...item, item_rank: index }))
    onChangeSignUpForm({ ...signUpForm, list_options_params })
  }

  _handleChange = params => {
    const { value, type, index } = params
    const {
      signUpForm: { list_options_params },
      onChangeSignUpForm,
      signUpForm
    } = this.props
    switch (type) {
      case 'item':
        list_options_params[index] = { ...list_options_params[index], item: value }
        break
      case 'count_limit':
        list_options_params[index] = { ...list_options_params[index], count_limit: value }
        break
      case 'description':
        list_options_params[index] = { ...list_options_params[index], description: value }
        break
    }
    onChangeSignUpForm({ ...signUpForm, list_options_params })
  }

  handleClick = () => {
    const {
      onButtonClick,
      signUpForm: { list_options_params }
    } = this.props
    if (!this.state.openSwitch) {
      for (const index in list_options_params) {
        this._handleChange({ type: 'count_limit', value: 9999, index })
      }
    }
    onButtonClick()
  }

  render() {
    const { openSwitch } = this.state
    const {
      signUpForm: { list_options_params }
    } = this.props

    return (
      <div className={styles['third-step-container']}>
        <ul className={styles['option-wrapper']}>
          {list_options_params.map((item, index) => (
            <Option
              onChange={this._handleChange}
              onRemove={this._removeOption}
              optionInformation={item}
              hasQuantity={openSwitch}
              key={index}
              index={index}
            />
          ))}
          <li className={styles['add-button-wrapper']} onClick={this._addOption}>
            <img src={AddIcon} alt="" width="16" />
            <span>add</span>
          </li>
        </ul>
        <div className={styles['quantity-switch-wrapper']}>
          <span className={styles['quantity-label']}>select quantity</span>
          <Switch
            onChange={checked => this.setState({ openSwitch: checked })}
            checked={openSwitch}
            uncheckedIcon={false}
            checkedIcon={false}
            onColor="#2cd4ae"
            width={50}
            height={30}
          />
        </div>
        <div className={styles['button-wrapper']} onClick={this.handleClick}>
          <Button className={styles['button-inner']}>
            <span>save and continue</span>
          </Button>
        </div>
      </div>
    )
  }
}

ThirdStep.propTypes = {
  signUpForm: PropTypes.object,
  onChangeSignUpForm: PropTypes.func,
  onButtonClick: PropTypes.func
}

function mapStateToProps(state) {
  return {
    signUpForm: state.frontend.signUpForm
  }
}

function mapDispatchToProps(dispatch) {
  return {
    onChangeSignUpForm: params => dispatch(changeSignUpForm(params))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ThirdStep)



// WEBPACK FOOTER //
// ./src/containers/time-poll/TimePollContainer/SignUp/CreateSignUp/ThirdStep/ThirdStep.jsx